import { Box, Typography, Button } from '@mui/material';
import homeBanner from '../assets/images/home-banner.png';

const HeroSection = () => (
    <Box 
    sx={{
        backgroundImage: `url(${homeBanner})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: 'white',
        py: 10,
        backgroundBlendMode: 'multiply',
        backgroundColor: '#6D9A5B',
        display: 'flex',
        height: { xs: 'fit-content', md: '60vh' },
        alignItems: 'center',
      }}
    >

  <Box
    sx={{
        textAlign: 'center',
        display: 'flex',
        textAlign: 'left',
        px: {xs: 4, md: 20},
        gap: 5,
        flexDirection: { xs: 'column', md: 'row' },
      }}
    >
    <Typography sx={{flex: '1 1'}} variant="h3" gutterBottom>
      Sustainably Crafted for the Modern World
    </Typography>
    <Box sx={{flex: '1 1', textAlign: 'left'}}>
    <Typography variant="body1" sx={{ maxWidth: 600, mb: 3 }}>
    At the intersection of nature and innovation, our Sustainable Bio Fuel production is meticulously designed to meet the demands of today’s environmentally conscious world. We prioritize sustainability at every step—from sourcing renewable raw materials to utilizing eco-friendly processes—ensuring minimal waste and maximum impact. Our products exemplify our commitment to a circular economy, providing valuable resources for industries and agriculture. Discover the perfect balance of high-performance green energy, responsible production, and environmental stewardship in every drop of Sustainable fuel we create.
    </Typography>
    <Button sx={{textTransform: 'none'}} variant="contained" size="large">
      Learn More
    </Button>
    </Box>
  </Box>
      </Box>
);

export default HeroSection;
